import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { InstagramIcon } from 'lucide-react';
import { Stars } from './Stars';
interface InstagramReview {
  name: string;
  initials: string;
  message: string;
}
const INSTAGRAM_REVIEWS: InstagramReview[] = [{
  name: 'Pablo García',
  initials: 'PG',
  message: 'Me ha encantado. Las plantillas me han ahorrado muchísimo tiempo preparando las clases de esta semana.'
}, {
  name: 'Marta López',
  initials: 'ML',
  message: 'La parte de adaptación por lesiones es justo lo que necesitaba para trabajar con más seguridad con mis grupos.'
}, {
  name: 'Sergio Díaz',
  initials: 'SD',
  message: 'Está muy bien ordenado y se aplica desde el primer día. Ya estoy usando la planificación con mis alumnos.'
}];
export function HeroSocialProof() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const shouldReduceMotion = useReducedMotion();
  const activeReview = INSTAGRAM_REVIEWS[activeIndex];
  useEffect(() => {
    if (paused || shouldReduceMotion) return;
    const interval = window.setInterval(() => {
      setActiveIndex(currentIndex => currentIndex === INSTAGRAM_REVIEWS.length - 1 ? 0 : currentIndex + 1);
    }, 4800);
    return () => window.clearInterval(interval);
  }, [paused, shouldReduceMotion]);
  return <section className="mt-8" aria-label="Opiniones de entrenadores" data-id="element-136" data-mp="3jer9jtlbcokc">
      <div className="mx-auto grid max-w-xs grid-cols-2 gap-2.5" data-id="element-137" data-mp="3fdxmf2fp3dsi">
        <div className="rounded-xl border border-white/10 bg-white/[0.04] px-3 py-3 text-center" data-id="element-138" data-mp="3tei23pqbcths">
          <p className="font-anton text-2xl leading-none text-white" data-id="element-139" data-mp="3ofx3tvumgjvz">+1000</p>
          <p className="mt-1 font-oswald text-xs font-700 uppercase tracking-wide text-neutral-300" data-id="element-140" data-mp="3oduezf57gwsu">
            coaches
          </p>
        </div>
        <div className="flex flex-col items-center justify-center rounded-xl border border-[#F5C518]/35 bg-[#F5C518]/[0.08] px-2 py-3" data-id="element-141" data-mp="1u2o24q8bi2oa">
          <Stars data-id="element-142" data-mp="3u5ynykk3evq0" />
          <p className="mt-1.5 font-anton text-xl leading-none text-white" data-id="element-143" data-mp="2xktdueq1jp7">4.8/5</p>
        </div>
      </div>

      <div className="mt-4 overflow-hidden rounded-2xl border border-white/10 bg-[#111]/95 shadow-xl" role="region" aria-roledescription="carrusel" aria-label="Mensajes de Instagram de entrenadores" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onFocusCapture={() => setPaused(true)} onBlurCapture={() => setPaused(false)} data-id="element-144" data-mp="6zft4uh07p0v">
        <div className="flex items-center gap-3 border-b border-white/10 px-4 py-3" data-id="element-145" data-mp="qmx0moqhnhov">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#F5C518]/50 bg-[#F5C518]/10 font-oswald text-xs font-700 text-[#F5C518]" data-id="element-146" data-mp="upa579ti19k2">
            H360
          </span>
          <div className="min-w-0 flex-1" data-id="element-147" data-mp="14meql7fit0zt">
            <p className="truncate text-[13px] font-700 text-white" data-id="element-148" data-mp="14n7t1w7g54c5">Ellos ya lo están aplicando</p>
            <p className="text-[11px] text-neutral-400" data-id="element-149" data-mp="1es6be3y6lvwb">Mensajes</p>
          </div>
          <InstagramIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-150" data-mp="19r0jg8ccicnu" />
        </div>

        <div className="min-h-[148px] px-4 py-4" data-id="element-151" data-mp="14tqm86ipswpg">
          <AnimatePresence initial={false} mode="wait" data-id="element-152" data-mp="10r3ndlnmmbir">
            <motion.article key={activeReview.name} initial={shouldReduceMotion ? false : {
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={shouldReduceMotion ? undefined : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.24,
            ease: [0.25, 1, 0.5, 1]
          }} aria-label={`Reseña de ${activeReview.name}`} data-id="element-153" data-mp="10sezc8r86pky">
              <div className="flex items-center gap-2.5" data-id="element-154" data-mp="1jpg721c5z3sl">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#F5C518] font-oswald text-xs font-700 text-black" data-id="element-155" data-mp="2g8driakg6azk">
                  {activeReview.initials}
                </span>
                <p className="text-[13px] font-700 text-white" data-id="element-156" data-mp="1vy2uvbkavz6o">{activeReview.name}</p>
              </div>

              <div className="ml-11 mt-2.5 rounded-2xl rounded-tl-sm bg-[#262626] px-3.5 py-3 text-[13px] leading-snug text-neutral-100" data-id="element-157" data-mp="20z0eztovf3at">
                {activeReview.message}
              </div>
              <p className="ml-11 mt-1.5 text-[10px] uppercase tracking-wide text-neutral-500" data-id="element-158" data-mp="1r0szlfa8ctax">
                Visto · Hace poco
              </p>
            </motion.article>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-1.5 border-t border-white/10 px-4 py-3" data-id="element-159" data-mp="2jo6wxehubqvk">
          {INSTAGRAM_REVIEWS.map((review, index) => <button key={review.name} type="button" onClick={() => setActiveIndex(index)} aria-label={`Ver opinión ${index + 1} de ${INSTAGRAM_REVIEWS.length}`} aria-current={index === activeIndex ? 'true' : undefined} className={`h-2 rounded-full transition-[width,background-color] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5C518] focus-visible:ring-offset-2 focus-visible:ring-offset-[#111] ${index === activeIndex ? 'w-5 bg-[#F5C518]' : 'w-2 bg-white/25'}`} data-id="element-160" data-mp="29ydrywc7ea0a" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}